import type { ReactNode } from 'react';

import { Box, Stack } from '@mui/material';

import { DimOverlay } from '@/pwa/atoms/DimOverlay/DimOverlay';
import { OnboardingAppBar } from '@/pwa/molecules/OnboardingAppBar/OnboardingAppBar';

export interface OnboardingPageTemplateProps {
  /** The section being answered. Omit to show the logo. */
  section?: string;
  /** Omit to show a person icon until the name is known. */
  initials?: string;
  /** Named in the settings sheet. */
  email?: string;
  onSignOut: () => void;
  onHelp: () => void;
  /** Dims the app bar with the chat behind a pinned card; omit to leave it undimmed. */
  isAppBarDimmed?: boolean;
  children: ReactNode;
}

/** OnboardingPageTemplate puts the onboarding app bar above a full-height page. */
export const OnboardingPageTemplate = ({
  section,
  initials,
  email,
  onSignOut,
  onHelp,
  isAppBarDimmed,
  children,
}: OnboardingPageTemplateProps) => {
  const appBar = (
    <OnboardingAppBar
      label={section}
      initials={initials}
      email={email}
      onSignOut={onSignOut}
      onHelp={onHelp}
    />
  );
  return (
    <Stack sx={{ height: '100%' }}>
      {isAppBarDimmed === undefined ? (
        appBar
      ) : (
        <Box sx={{ position: 'relative' }}>
          {appBar}
          <DimOverlay isShown={isAppBarDimmed} />
        </Box>
      )}
      <Box sx={{ flex: 1, minHeight: 0 }}>{children}</Box>
    </Stack>
  );
};

OnboardingPageTemplate.displayName = 'OnboardingPageTemplate';
export default OnboardingPageTemplate;
